import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HeroImage } from './components/HeroImage';
import { ProblemIdentification } from './components/ProblemIdentification';
import { ProblemAgitation } from './components/ProblemAgitation';
import { PromiseSection } from './components/PromiseSection';
import { ProductPresentation } from './components/ProductPresentation';
import { ResultsSection } from './components/ResultsSection';
import { ScienceSection } from './components/ScienceSection';
import { AudienceSection } from './components/AudienceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStack } from './components/ValueStack';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { UrgencyClose } from './components/UrgencyClose';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-text-black selection:bg-sage selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HeroImage data-id="element-3" />
        <ProblemIdentification data-id="element-4" />
        <ProblemAgitation data-id="element-5" />
        <PromiseSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <ScienceSection data-id="element-9" />
        <AudienceSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <ValueStack data-id="element-12" />
        <PricingSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <UrgencyClose data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <RecentPurchaseToast data-id="element-18" />
    </div>;
}